import React from 'react'

import './Footer.css'

import {
  FooterContainer,
  SocialIconListItem,
  SocialIcon,
  CopyrightContainer,
} from './Footer.css.js';

export default ({ globalSettings, socialSettings, navLinks, currentYear }) => {
  const socialIconsData = [
    {
      link: `https://twitter.com/CeMontessori`,
      iconUrl: `/images/ce-montessori/social-icons/twitter.svg`,
      altText: `c'e Montessori Twitter`,
    },
    {
      link: `https://www.pinterest.com/cemontessor1372/`,
      iconUrl: `/images/ce-montessori/social-icons/pinterest.svg`,
      altText: `c'e Montessori Pinterest`,
    },
    {
      link: `https://www.facebook.com/Montessoribrooklyn`,
      iconUrl: `/images/ce-montessori/social-icons/facebook.svg`,
      altText: `c'e Montessori Facebook`,
    },
    {
      link: `https://instagram.com/montessoribrooklyn/`,
      iconUrl: `/images/ce-montessori/social-icons/instagram.svg`,
      altText: `c'e Montessori Instagram`,
    }
  ];

  const socialIcons = socialIconsData.map((socialIcon, index) =>
    <SocialIconListItem
      key={index}
    >
      <a href={socialIcon.link} target="_blank">
        <SocialIcon
          src={socialIcon.iconUrl}
          alt={socialIcon.alt}
        />
      </a>
    </SocialIconListItem>
  );

  return (
    <FooterContainer>
      <div className='Footer--Lower'>
        <div className='container taCenter'>

          <div className="ce-footer-social-icons-container">
            <div className="ce-footer-social-icons-container-inner container">
              <div className="ce-footer-left-container col-xs-12 col-sm-10">
                <ul className="ce-footer-social-icons-list">
                  {socialIcons}
                </ul>
                <CopyrightContainer>
                  &copy;{currentYear} c'e Montessori <span className="no-wrap">All Rights Reserved.</span>
                </CopyrightContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FooterContainer>
  )
}
